
function padTo2Digits(num) {
  return num.toString().padStart(2, "0");
}
export const getTime = (timestamp) => {
  let epoch_time = timestamp * 1000;
  var date_obj = new Date(epoch_time);
  const hours = date_obj.getHours();
  const minutes = date_obj.getMinutes();
  const time = `${padTo2Digits(hours)}:${padTo2Digits(minutes)}`;
  return time;
};

export const getDateold = (timestamp) => {
  var currentDate = new Date(timestamp * 1000);
  const currentDayOfMonth = currentDate.getDate();
  const currentMonth = currentDate.getMonth(); // Be careful! January is 0, not 1
  const currentYear = currentDate.getFullYear();

  const dateString =
    currentDayOfMonth + "/" + (currentMonth + 1) + "/" + currentYear;
  return dateString;
};

export const getDate = (timestamp) => {
  Date.prototype.monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  Date.prototype.getMonthName = function () {
    return this.monthNames[this.getMonth()];
  };
  Date.prototype.getShortMonthName = function () {
    return this.getMonthName()?.substr(0, 3);
  };

  var currentDate = new Date(timestamp * 1000);
  const currentDayOfMonth = currentDate?.getDate();
  const currentMonth = currentDate?.getMonth(); // Be careful! January is 0, not 1
  const currentYear = currentDate?.getFullYear();

  return (
    ("0" + currentDayOfMonth)?.slice(-2) +
    " " +
    currentDate?.getShortMonthName()
  );

  //   const dateString =
  //     currentDayOfMonth + "/" + (currentMonth + 1) + "/" + currentYear;
  //   return dateString;
};

export const getDay = (timestamp) => {
  return new Date(timestamp * 1000)?.toString()?.substring(0, 3);
};

export const formatYaxisNumber = (ynum) => {
  
  if (isNaN(ynum)) {
    return ynum;
  } else if (ynum < 0) {
    return parseInt(ynum / -100000) > 0
      ? parseFloat(ynum / 100000)
          .toFixed(1)
          .replace(/\.0+$/, "") + " l"
      : parseInt(ynum / -1000) > 0
      ? parseFloat(ynum / 1000)
          .toFixed(1)
          .replace(/\.0+$/, "") + " k"
      : ynum;
  } else {
    return parseInt(ynum / 100000) > 0
      ? parseFloat(ynum / 100000)
          .toFixed(1)
          .replace(/\.0+$/, "") + " l"
      : parseInt(ynum / 1000) > 0
      ? parseFloat(ynum / 1000)
          .toFixed(1)
          .replace(/\.0+$/, "") + "k"
      : ynum;
  }
};

export const RevenueformatYaxisNumber = (value) => {
  var val = Math.abs(value)
  if (val >= 10000000) {
      val = (val / 10000000) + ' Cr';
  } else if (val >= 100000) {
      val = (val / 100000) + ' L';
  }
  else if (val >= 1000) {
      val = (val / 1000) + ' K';
  }
  return val;
};
